import phoneMask from '@/utils/phoneMask';

export function formatPhoneNumber (number) {
    if (!number) return '';
    let i = 0;
    const v = number.toString().replace(/\s/g, '');
    const pattern = phoneMask(v);
    return pattern.replace(/#/g, (_) => v[i++]);
}
